import React, { ReactElement } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { styled, alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const BackgroundImage = `${process.env.PUBLIC_URL}/bgimg.jpg`;

const Root = styled('div')(({ theme }) => ({
  background: `url(${BackgroundImage}) no-repeat fixed center center`,
  backgroundSize: 'cover',
  height: '100vh',
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: alpha(theme.palette.grey[300], 0.77),
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  backgroundColor: alpha(theme.palette.background.paper, 0.4),
  padding: theme.spacing(8),
  boxShadow: 'none',
  maxWidth: 950,
  borderRadius: 25,
  [theme.breakpoints.down('md')]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

export const AuthenticationInProgress = (): ReactElement => {
  const { t } = useTranslation('common');

  return (
    <Root>
      <StyledCard>
        <CardContent>
          <Typography variant="h2" gutterBottom sx={{ mb: 8 }}>
            {t('authentication.inProgress', 'Waiting for authentication...')}
          </Typography>
          <LinearProgress color="secondary" sx={{ width: '100%' }} />
        </CardContent>
      </StyledCard>
    </Root>
  );
};

export default AuthenticationInProgress;
